import { render, staticRenderFns } from "./CFormFieldset.vue?vue&type=template&id=03f5d6cb&scoped=true&"
import script from "./CFormFieldset.vue?vue&type=script&lang=js&"
export * from "./CFormFieldset.vue?vue&type=script&lang=js&"
import style0 from "./CFormFieldset.vue?vue&type=style&index=0&id=03f5d6cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f5d6cb",
  null
  
)

export default component.exports